import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import globalClasses from "../../commoncomponents/css/Global.module.css";
import CommonLayout from "../../commoncomponents/layout/CommonLayout";
import { getRequest } from "../../../api/AxiosAPICall";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../commoncomponents/alert/SnackbarAction";
const PaymentSuccess = () => {
  const location = useLocation();
  const isMounted = useRef<any>();
  const [paymentStatus, setPaymentStatus] = useState("");
  const dispatch = useDispatch();
  const [cellmaURL, setCellmaURL] = useState("");
  const fetchCellmaPreference = async () => {
    await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "cellmaflex_cellma_url",
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setCellmaURL(response.data);
      }
    });
  };
  useEffect(() => {
    isMounted.current = true;
    if (location?.state?.registerPayment !== undefined) {
      setPaymentStatus(location.state.registerPayment);
    }

    fetchCellmaPreference();
    return () => {
      isMounted.current = false;
      setPaymentStatus("");
    };
  }, [location]);
  return (
    <CommonLayout footer={true}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <>
          <Typography
            variant="h6"
            sx={{ textAlign: "center" }}
            className={globalClasses.typography}
          >
            Welcome to Cellmaflex!
          </Typography>

          <Typography
            sx={{
              fontSize: "14px !important",
              textAlign: "left !important",
            }}
            component="div"
            className={globalClasses.typography}
          >
            Please read the following before proceeding further.
            <br></br>
            <strong>1. Your Account</strong>
            <br></br>
            Update all the information <Link to={"/signin"}>here</Link> on your
            doctor’s profile, including
            <ul>
              <li>Your profile picture.</li>
            </ul>
            <ul>
              <li>Your website and social media links.</li>
            </ul>
            <ul>
              <li>
                Your background information such as education, awards, special
                research etc.
              </li>
            </ul>
            <strong>2. Your Schedule</strong>
            <br></br>
            To see if you have any appointments and scheduled visits,
            <a href={cellmaURL}>click here</a> . You would be required to log{" "}
            <br></br> into your FREE personalized electronic clinic on Cellma to
            view all appointments. <br></br>Once an appointment is booked, you
            would receive a notification via email, you can also update your
            <br></br> Outlook Calendar from here.
            <br></br>
            <br></br>
            Cellma access also allows you to view and update the patient’s
            medical records.
            <br></br>
            <br></br>
            Cellma log-in credentials are the same as your Cellmaflex log-in.
            <br></br>
            <br></br>
            <strong>3. Flexibility in Consultations</strong>
            <br></br>
            Cellmaflex also allows you the ability to provide telemedicine
            features such as video consultations. <br></br>
            Patients can book either in clinic consultations or video
            consultations through the Teams app. <br></br>
            This functionality is also made available through Cellma.
            <br></br>
            <br></br>
            If your payment has failed, please proceed to your user profile to
            complete the payment.
          </Typography>
        </>

        {paymentStatus === "authenticated" && (
          <Box
            className={globalClasses.loader}
            sx={{ marginTop: { xs: "20px", md: "150px" } }}
          >
            <CircularProgress color="primary" disableShrink />
          </Box>
        )}
      </Box>
    </CommonLayout>
  );
};
export default PaymentSuccess;
